import { Mail, MapPin, Phone } from "lucide-react";
import { Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";
import { ADDRESS_ONE_LINE, BUSINESS, MAPS_URL } from "@/lib/site";

export function AboutLocation() {
  const photo = PHOTOS.parkModelCarport;

  return (
    <section
      className="relative isolate overflow-hidden bg-forest-deep py-24 sm:py-28 lg:py-36"
      aria-labelledby="location-title"
    >
      <img
        src={photo.src}
        srcSet={photo.srcSet}
        sizes={PHOTO_SIZES.fullBleed}
        alt=""
        width={photo.width}
        height={photo.height}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 -z-10 size-full object-cover"
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 -z-10 bg-[linear-gradient(105deg,oklch(0.259_0.042_163.6/0.94)_0%,oklch(0.259_0.042_163.6/0.78)_48%,oklch(0.259_0.042_163.6/0.55)_100%)]"
        aria-hidden="true"
      />

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 sm:px-6 lg:grid-cols-[1.2fr_0.9fr] lg:items-end lg:gap-16 lg:px-10">
        <Reveal className="max-w-2xl text-cream">
          <p className="eyebrow text-sand">Discover Zapata</p>
          <h2
            id="location-title"
            className="mt-5 text-balance font-display text-3xl leading-[1.1] sm:text-4xl lg:text-[3rem]"
          >
            Close to Falcon Lake and the Heart of the Community
          </h2>
          <p className="mt-6 text-base leading-relaxed text-cream/85 sm:text-lg">
            Amigo Inn &amp; RV Park gives guests a peaceful place to stay near Falcon Lake while
            keeping them close to Zapata. The area is known for fishing, boating, friendly local
            hospitality, South Texas culture, and a distinctive blend of Texan and Mexican
            traditions.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="rounded-sm border border-cream/20 bg-forest-deep/70 p-6 text-cream backdrop-blur-sm sm:p-8">
            <p className="font-display text-xl">{BUSINESS.name}</p>
            <address className="mt-4 space-y-3 text-sm not-italic text-cream/85">
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline items-start"
              >
                <MapPin className="mt-0.5 size-4 shrink-0 text-sand" aria-hidden="true" />
                <span>
                  {BUSINESS.street}
                  <br />
                  {BUSINESS.city}, {BUSINESS.region} {BUSINESS.postalCode}
                </span>
              </a>
              <a href={BUSINESS.phoneHref} className="link-underline">
                <Phone className="size-4 shrink-0 text-sand" aria-hidden="true" />
                {BUSINESS.phone}
              </a>
              <a href={`mailto:${BUSINESS.email}`} className="link-underline">
                <Mail className="size-4 shrink-0 text-sand" aria-hidden="true" />
                {BUSINESS.email}
              </a>
            </address>

            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="link-underline mt-6 inline-flex text-sm font-semibold text-sand"
              aria-label={`Get directions to ${BUSINESS.name} at ${ADDRESS_ONE_LINE}`}
            >
              Get Directions
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
